<template>
  <v-row no-gutters>
    <v-col cols="12" class="px-2 coin-rewards-dialog">
      <v-row no-gutters>
        <v-col cols="12">
          <div class="coin">
            <img loading="lazy" src="/static/image/icon/coinicon.png" width="120" alt="nagad88 coin" />
            <p>x10</p>
          </div>
          <p class="congratulations-title">{{ $t('label.congratulations') }}</p>
          <p class="text-center">
            {{ $t('label.trigger_redirect_wof_msg_1') }}
            <span class="orange--text">{{ $t('label.trigger_redirect_wof_msg_2') }}</span>
            {{ $t('label.trigger_redirect_wof_msg_3') }}
          </p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <app-button class="full-width white--text dialog-button" :title="$t(`button.tryYourLuckNow`)" :action="this.goToWOFPage"></app-button>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { ROUTE_NAME } from '@/constants/route.constants'
import { uiHelper } from '@/util'
import { DevicePlatform } from '@/constants/enums'
export default {
  name: 'coinRewards',
  props: {
    closeDirectToWOFDialogShow: {
      type: Function,
      required: true,
      default: () => {}
    }
  },
  created() {},
  methods: {
    goToWOFPage() {
      if (uiHelper.getPlatform() == DevicePlatform.DESKTOP) {
        this.$router.push({
          name: ROUTE_NAME.WOF,
          params: {
            lang: this.$route.params.lang
          }
        })
      } else {
        this.$router.push({
          name: ROUTE_NAME.MWOF,
          params: {
            lang: this.$route.params.lang
          }
        })
      }
      this.closeDirectToWOFDialogShow()
    }
  }
}
</script>

<style lang="scss">
.coin-rewards-dialog {
  font-size: 14px;
  color: black;

  .coin {
    display: flex;
    font-size: 16px;
    font-weight: bolder;
    justify-content: center;
    margin-bottom: 8px;
    color: var(--v-secondary-base);

    p {
      margin-left: -14px;
    }
  }

  .congratulations-title {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 4px;
  }

  .dialog-divider {
    background-color: black;
  }
}
</style>
